import {sendValoresM,sendValoresH,sendSumas,successCotizacion} from '../reducers/todo-reducer';
import * as firebase from 'firebase';
import {properties} from '../properties/properties';
import axios from 'axios';

export default  {

	getValoresM(values){
		return new Promise((resolve,reject)=>{
            try{

                const database = firebase.database();
                const ref = database.ref('valores_vida/valoresM');

                ref.once("value",(data)=>{
                    if(data.val()!== null){
                        var mJson = JSON.stringify(data.val());
                        resolve({valoresM:JSON.parse(mJson)});
                    }
                });
            }catch(error){
                console.log(error);
                reject({messageError : "Ocurrio un error en la petición de valoresM"});
            }

		}).then(sendValoresM);
    },
    getValoresH(values){
		
		return new Promise((resolve,reject)=>{
           try{
                const database = firebase.database();
                const ref = database.ref('valores_vida/valoresH');

                ref.once("value",(data)=>{
                    if(data.val()!== null){
                        var mJson = JSON.stringify(data.val());
                        resolve({valoresH:JSON.parse(mJson)});
                    }
                });
            }catch(error){
                console.log(error);
                reject({messageError : "Ocurrio un error en la petición de valoresH"});
            }

		}).then(sendValoresH);
    },
    getSumas(){
        return new Promise((resolve,reject)=>{
             try{
                const database = firebase.database();
                const ref = database.ref('valores_vida/sumasAseguradas/');

                ref.once("value",(data)=>{
                    if(data.val()!== null){
                
                        var sumas = [];

                        for(var i=0; i<data.val().length; i++){
                            if(data.val()[i]){
                                sumas.push(data.val()[i]);
                            }
                        }

                        console.log(sumas);

                        resolve({sumasAseguradas:sumas});
                    }
                });
            }catch(error){
                console.log(error);
                reject({messageError : "Ocurrio un error en la petición de sumas"});
            }
        }).then(sendSumas);
    },
    getCotizacion(values){
       return new Promise((resolve,reject)=>{
            var url = properties().COTIZA_VIDA;
            axios({
                method: 'post',
                url: url,
                data: values,
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': properties().API_KEY
                }
            }).then((response) => {
                if(response){
                    console.log("DIEGO", response.data);
                    var resultado = response.data;
                    resolve(resultado);
                }else{
                    resolve(false);
                }
            }).catch((error) => {
                resolve(false);
            });	
 
        }).then(successCotizacion);
    }

}



// WEBPACK FOOTER //
// ./src/apis/todo-api.js